export const parseTextSmart = (text) => {
    if (!text || typeof text !== 'string') return [];
    const lines = text.split('\n').filter(line => line && line.trim());
    const items = [];
    
    // Регулярні вирази для різних форматів
    const patterns = [
      // "Монтаж кондиціонера - 3 шт по 3500"
      /^(.+?)\s*[-–—]\s*(\d+(?:[.,]\d+)?)\s*(шт|м\.?п|м²|м2|м³|м3|посл|компл|кг|л|год)\.?\s*(?:по|х|x|\*)\s*(\d+(?:[.,]\d+)?)/i,
      
      // "Монтаж кондиціонера 3шт 3500грн"
      /^(.+?)\s+(\d+(?:[.,]\d+)?)\s*(шт|м\.?п|м²|м2|м³|м3|посл|компл|кг|л|год)\.?\s+(\d+(?:[.,]\d+)?)\s*(?:грн|₴)?/i,
      
      // "Монтаж кондиціонера | 3 | шт | 3500"
      /^(.+?)\s*[|;]\s*(\d+(?:[.,]\d+)?)\s*[|;]\s*(шт|м\.?п|м²|м2|м³|м3|посл|компл|кг|л|год)\.?\s*[|;]\s*(\d+(?:[.,]\d+)?)/i,
      
      // "3 шт Монтаж кондиціонера 3500"
      /^(\d+(?:[.,]\d+)?)\s*(шт|м\.?п|м²|м2|м³|м3|посл|компл|кг|л|год)\.?\s+(.+?)\s+(\d+(?:[.,]\d+)?)\s*(?:грн|₴)?$/i,
      
      // "Монтаж кондиціонера 3*3500" або "Монтаж 3х3500"
      /^(.+?)\s+(\d+(?:[.,]\d+)?)\s*[*хx×]\s*(\d+(?:[.,]\d+)?)\s*(?:грн|₴)?$/i,
      
      // "Монтаж кондиціонера 10500грн" (тільки сума)
      /^(.+?)\s+(\d+(?:[.,]\d+)?)\s*(?:грн|₴)$/i,
      
      // "1. Монтаж кондиціонера - 3500 грн"
      /^\d+[.)]\s*(.+?)\s*[-–—]\s*(\d+(?:[.,]\d+)?)\s*(?:грн|₴)?$/i,
    ];
    
    // Нормалізація одиниць виміру
    const normalizeUnit = (unit) => {
      if (!unit) return 'шт.';
      const u = unit.toLowerCase().replace(/\./g, '');
      const unitMap = {
        'шт': 'шт.', 'штук': 'шт.', 'штуки': 'шт.',
        'мп': 'м.п.', 'м п': 'м.п.', 'пм': 'м.п.',
        'м2': 'м²', 'м 2': 'м²', 'кв м': 'м²', 'квм': 'м²',
        'м3': 'м³', 'м 3': 'м³', 'куб м': 'м³', 'кубм': 'м³',
        'посл': 'посл.', 'послуга': 'посл.',
        'компл': 'компл.', 'комплект': 'компл.',
        'кг': 'кг', 'кілограм': 'кг',
        'л': 'л', 'літр': 'л',
        'год': 'год.', 'година': 'год.'
      };
      return unitMap[u] || 'шт.';
    };
    
    // Очищення назви
    const cleanPosition = (text) => {
      if (!text) return '';
      return text
        .replace(/^\d+[.)]\s*/, '') // Прибираємо нумерацію
        .replace(/[-–—]\s*$/, '') // Прибираємо тире в кінці
        .replace(/\s+/g, ' ')
        .trim();
    };
    
    // Парсимо число
    const parseNum = (str) => {
      if (!str) return 0;
      return parseFloat(str.toString().replace(/\s/g, '').replace(',', '.')) || 0;
    };
    
    lines.forEach((line, idx) => {
      const trimmedLine = line.trim();
      
      // Пропускаємо рядки з "всього", "разом", заголовки
      if (/^(всього|разом|підсумок|итого|сума|total|№|п\/п|найменування|кількість|ціна|вартість)/i.test(trimmedLine)) {
        return;
      }
      
      // Пропускаємо короткі рядки
      if (trimmedLine.length < 3) return;
      
      let matched = false;
      
      // Пробуємо кожен патерн
      for (const pattern of patterns) {
        const match = trimmedLine.match(pattern);
        if (match) {
          let position, qty, unit, price;
          
          // Різна логіка для різних патернів
          if (pattern.source.includes('шт|м')) {
            // Патерни з одиницею виміру
            if (pattern.source.startsWith('^(\\d')) {
              // "3 шт Монтаж 3500"
              [, qty, unit, position, price] = match;
            } else if (pattern.source.includes('[*хx×]')) {
              // "Монтаж 3*3500"
              [, position, qty, price] = match;
              unit = 'шт.';
            } else {
              // Звичайні патерни
              [, position, qty, unit, price] = match;
            }
          } else if (pattern.source.includes('грн|₴')) {
            // "Монтаж 10500грн"
            [, position, price] = match;
            qty = 1;
            unit = 'посл.';
          }
          
          position = cleanPosition(position);
          
          if (position && position.length > 2) {
            items.push({
              id: Date.now() + idx + Math.random(),
              type: 'Робота',
              position: position.charAt(0).toUpperCase() + position.slice(1),
              unit: normalizeUnit(unit),
              qty: parseNum(qty) || 1,
              workPrice: Math.round((parseNum(price) || 0) * 100) / 100,
              markup: 20,
              selected: true
            });
            matched = true;
            break;
          }
        }
      }
      
      // Якщо жоден патерн не спрацював - базовий парсинг
      if (!matched) {
        // Шукаємо числа в рядку
        const numbers = trimmedLine.match(/\d+(?:[.,]\d+)?/g)?.map(n => parseNum(n)) || [];
        const textPart = trimmedLine
          .replace(/\d+(?:[.,]\d+)?/g, ' ')
          .replace(/[грн₴шт.м²м³м.п.кг л посл компл год]/gi, ' ')
          .replace(/[-–—|;:]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        
        if (textPart && textPart.length > 2 && numbers.length >= 1) {
          items.push({
            id: Date.now() + idx + Math.random(),
            type: 'Робота',
            position: textPart.charAt(0).toUpperCase() + textPart.slice(1),
            unit: 'шт.',
            qty: numbers.length > 1 ? numbers[0] : 1,
            workPrice: Math.round((numbers.length > 1 ? numbers[1] : numbers[0]) * 100) / 100,
            markup: 20,
            selected: true
          });
        }
      }
    });
    
    return items;
  };
